/* eslint-disable accessor-pairs */
const eventBus = window.theme.searchAutocomplete.eventBus

class SearchAutoCompleteStateLayer {
  constructor () {
    this.state = {
      term: '',
      keywords: [],
      products: [],
    }

    // Subscribe to events
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    // Subscribe to search term updates

    eventBus.subscribe('searchAutoComplete:ui:term:updated', (response) => {
      const { term } = response
      this.term = term
    })

    // Subscribe to API results fetched

    eventBus.subscribe('searchAutoComplete:api:results:fetched', (response) => {
      const { keywords, products } = response
      this.keywords = keywords
      this.products = products

      eventBus.publish('searchAutoComplete:state:updated', this.state)
    })
  }

  set term (term) {
    this.state.term = term
    eventBus.publish('searchAutoComplete:state:term:updated', term)
  }

  set keywords (keywords) {
    this.state.keywords = keywords
  }

  set products (products) {
    this.state.products = products
  }
}

window.theme.searchAutocomplete.stateLayer = new SearchAutoCompleteStateLayer()
